/**
 * Server opinion on whether a changed record belongs in a subscribed list view.
 */
export enum ListDispositionEnum {
  /** The record may belong in the list. `data` is included on the event. */
  INCLUDE = 'include',
  /** The record should be removed from the list. */
  EXCLUDE = 'exclude',
  /** The server cannot decide. The client should refetch the list. */
  REVALIDATE = 'revalidate',
}
